<ng-container *ngIf="pageData$ | async">
  <div *ngIf="error$ | async as error" class="error-banner">
    {{ error }}
  </div>

  <ng-container [ngSwitch]="carouselType">

    <app-carousel1
      *ngSwitchCase="'carousel-1'"
      [slides]="carouselSlides"
      [titleColor]="carouselTitleColor"
      [descriptionColor]="carouselDescriptionColor">
    </app-carousel1>

    <app-carousel2
      *ngSwitchCase="'carousel-2'"
      [slides]="carouselSlides">
    </app-carousel2>

    <app-carousel1
      *ngSwitchDefault
      [slides]="carouselSlides"
      [titleColor]="carouselTitleColor"
      [descriptionColor]="carouselDescriptionColor">
    </app-carousel1>

  </ng-container>

  <div class="container-fluid about-wrapper" id="ABOUT_US">
     <!-- LOTUS DECORATION -->
    <img
      src="assets/images/lotus.jpg"
      class="lotus-bloom"
      alt="Lotus Decoration"
    />
    <div class="section-heading">
      <u>&nbsp;&nbsp;About</u>&nbsp;<u>Us&nbsp;&nbsp;</u>
    </div>
    <div class="row align-items-center message-row" id="about-us">
      <div class="col-lg-5 col-12 order-1 text-center">
        <div
          class="image-shadow-container"
          [class.expanded]="showAboutFull"
          [style.--image-url]="'url(' + (aboutUsImage) + ')'"
        >
          <img
            class="main-image"
            [src]="aboutUsImage"
            alt="About Us"
          />
        </div>
      </div>

      <div class="col-lg-7 col-12 order-2">
        <div class="message-text" style="text-align: justify;">

          <!-- CASE 1: About Us content exists -->
          <ng-container *ngIf="aboutUsContent as auc; else defaultMessage" >
            <div
              class="collapsible-content"
              [class.collapsed]="!showAboutFull"
              [innerHTML]="auc.content">
            </div>
          </ng-container>

          <!-- CASE 2: Fallback hardcoded message -->
          <ng-template #defaultMessage>
            <div
              class="collapsible-content"
              [class.collapsed]="!showAboutFull">
              Education is a lifelong journey, and a strong beginning sets the tone for everything that follows. At our school, we believe this foundation is built by nurturing curiosity and a genuine love for learning. Our classrooms, laboratories, and activity spaces are thoughtfully designed to enhance productivity while ensuring students are protected from excessive noise and pollution.  
              We encourage our learners to think independently and strengthen their analytical and problem-solving abilities.  
              Special tutorial and remedial sessions—conducted both during school and after hours—are arranged based on each child’s needs. Students are constantly engaged in meaningful activities that spark intellectual growth. The subjects offered, such as English, Hindi, Mathematics, E.V.S., General Knowledge, and Computer Studies, broaden their understanding and prepare them to handle real-life situations effectively.  
              A rich range of co-curricular activities further supports the all-round development of every student. At every grade level, learners are challenged academically and personally, and our faculty guides them—whether in the classroom, the laboratory, or on stage—to gain confidence and competence across various disciplines.
              Our academic programme aims to equip students with the knowledge, skills, and attitudes essential for success in a global, evolving world. They are supported by a team of highly competent and dedicated educators who bring both expertise and passion to the classroom.  
              Continuous professional development ensures that our teachers grow in areas such as effective teaching practices, inclusion, technology, and subject-specific excellence.  
              Remedial support is provided whenever needed, and students are engaged in constructive, thought-provoking tasks that promote deep learning. With diverse subjects like English, Hindi, Mathematics, E.V.S., General Knowledge, and Computers, we foster broader thinking and practical readiness.  
              Alongside academics, a wide spectrum of co-curricular opportunities ensures students develop holistically. We are committed to maintaining an inclusive and equitable learning environment where every child has the chance to participate, grow, and contribute meaningfully to school life.
            </div>
          </ng-template>

          <a (click)="showAboutFull = !showAboutFull" class="read-more-link">
            {{ showAboutFull ? '(Read Less)' : '...(Read More)' }}
          </a>
          <!-- <a routerLink="/aboutUs-v2"  class="read-more-link">Read More</a> -->
        </div>
      </div>

    </div>
  </div> 

  <app-people-behind-vision>
  </app-people-behind-vision>

<div
  class="container-fluid px-4 text-center school-events"
  *ngIf="schEventImages.length; else noSchoolEvents"
>
  <div class="section-heading">
    <u>&nbsp;&nbsp;Life</u>&nbsp;<u>At Our School&nbsp;&nbsp;</u>
  </div>

  <div class="events-grid">
    <div
      class="event-card pointer fade-in"
      *ngFor="let event of schEventImages | slice:0:3"
      [routerLink]="['/gallery']"
    >
      <div class="image-container">
        <img [src]="event.imageUrl" [alt]="event.title" />
        <div class="image-text">
          <p style="background-color: white;">{{ event.title }}</p>
        </div>
      </div>
    </div>
  </div>
</div>


  <div class="container-fluid px-4 text-center school-events" *ngIf="showFacilities; else noFacilities">
    <div class="section-heading">
      <u>&nbsp;&nbsp;Excellence</u>&nbsp;<u>in Infrastructure&nbsp;&nbsp;</u>
    </div>
    <app-facilities></app-facilities>
  </div>

  <div class="container-fluid px-4 text-center school-events" *ngIf="showHighlights; else noHighlights">
    <div class="section-heading">
      <u>&nbsp;&nbsp;{{ featuredImageTitle }}&nbsp;&nbsp;</u>
    </div>

    <app-image-showcase>
    </app-image-showcase>
  </div>

  <ng-template #noFacilities>
  <div class="container-fluid px-4 text-center school-events">
    <div class="section-heading">
      <u>&nbsp;&nbsp;Excellence</u>&nbsp;<u>in Infrastructure&nbsp;&nbsp;</u>
    </div>

    <div class="empty-section">
      <mat-icon>apartment</mat-icon>
      <p>Infrastructure details will be available soon.</p>
    </div>
  </div>
</ng-template>

<ng-template #noHighlights>
  <div class="container-fluid px-4 text-center school-events">
    <div class="section-heading">
      <u>&nbsp;&nbsp;{{ featuredImageTitle || 'Highlights' }}&nbsp;&nbsp;</u>
    </div>

    <div class="empty-section">
      <mat-icon>photo_library</mat-icon>
      <p>Highlights will be available soon.</p>
    </div>
  </div>
</ng-template>

<ng-template #noSchoolEvents>
  <div class="container-fluid px-4 text-center school-events">
    <div class="section-heading">
      <u>&nbsp;&nbsp;Life</u>&nbsp;<u>At Our School&nbsp;&nbsp;</u>
    </div>

    <div class="empty-section">
      <mat-icon>event_busy</mat-icon>
      <p>No events available at the moment.</p>
    </div>
  </div>
</ng-template>

  <section *ngIf="showDigitalSchoolSection" class="features" aria-labelledby="features-title">
    <header class="features__header">
      <div id="features-title"  class="section-heading">
        <u>&nbsp;&nbsp;Digitally Powered</u>&nbsp;<u>Physical School&nbsp;&nbsp;</u>
      </div>
      <p class="features__subtitle">
        Our school. Digitally connected. Seamlessly managed.
      </p>
    </header>

    <div class="features__grid" role="list">
      <article
        class="feature-card"
        *ngFor="let feature of features; trackBy: trackByTitle"
        [style.--card-bg]="feature.gradient"
        tabindex="0"
        role="listitem"
      >
        <span class="feature-card__icon" aria-hidden="true">
          {{ feature.icon }}
        </span>
        <h2 class="feature-card__title">
          {{ feature.title }}
        </h2>
      </article>
    </div>

    <footer class="features__watermark">
      Powered by
      <a
        href="https://educastack.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        EducaStack
      </a>
    </footer>
  </section>

  <app-home-faq class="faq"></app-home-faq>

  <app-admission-update
    [categoryMap]="homeCategoryMap">
  </app-admission-update>
  
  <section class="achievements" aria-labelledby="achievements-title" *ngIf="achievementImages.length">
    <div class="section-heading">
      <u>&nbsp;&nbsp;Excellence</u>&nbsp;&&nbsp;<u>Achievements&nbsp;&nbsp;</u>
    </div>

    <app-achievements [toppers]="achievementImages"></app-achievements>
  </section>

  <app-contact-us></app-contact-us>


  <button
    mat-flat-button
    color="primary"
    class="enquiry-button"
    (click)="openEnquiry()">
    <mat-icon class="icon">question_answer</mat-icon>
    Enquiry
  </button>

  <app-enquiry-dialog
    *ngIf="showEnquiry"
    (closes)="closeEnquiry()">
  </app-enquiry-dialog>


  <div style="height:20px"></div>

  <div class="news-ticker">
    <div class="news-label">Latest News</div>
    <div class="news-marquee">
      <div class="news-text">
        <ng-container *ngFor="let news of latestNews; let last = last">
          {{ news.title }}
          <span *ngIf="news.isNew" class="new-badge">NEW</span>

          <ng-container *ngIf="!last">
            &nbsp;&nbsp; | &nbsp;&nbsp;
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
<app-news-notice-overlay-v2 *ngIf="newsHeaderText && !isMobile"
  [newsList]="latestNews"
  [newsHeaderBackground]="newsHeaderBackground"
  [newsHeaderColor]="newsHeaderColor"
  [newsHeaderText]="newsHeaderText">
</app-news-notice-overlay-v2>


</ng-container>